module.exports = __webpack_public_path__ + "static/media/iconService2.4c2a3af3.svg";